import InfoIcon from '@mdi/svg/svg/information-outline.svg?react';
import { Center, Flex, IconWithTooltip } from '@solinkcorp/solink-components';
import classNames from 'classnames';
import './EventTimePicker.sass';

interface EventTimePickerDurationProps {
  title: string;
  duration: string;
  infoTooltip?: string;
  className?: string;
}
export default function EventTimePickerDuration(props: EventTimePickerDurationProps) {
  const { title, duration, infoTooltip, className } = props;
  return (
    <Flex
      className={classNames(className, 'time-section')}
      flexDirection="column"
      data-testid="time-duration-section"
    >
      <Flex gap="0.25rem" alignItems="center" className="time-section-title duration-title">
        {title}
        {!!infoTooltip && (
          <IconWithTooltip
            icon={InfoIcon}
            className="event-timepicker-info-icon"
            title={infoTooltip}
          />
        )}
      </Flex>
      <Center className="duration">
        <div>{duration}</div>
      </Center>
    </Flex>
  );
}
